import { render, staticRenderFns } from "./BTableItemAte.vue?vue&type=template&id=4b66467d&"
import script from "./BTableItemAte.vue?vue&type=script&lang=js&"
export * from "./BTableItemAte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports